import CartTableController from './cart-table.controller';

require('./cart-table.scss');

const CartTableComponent = {
    selector: 'sbCartTable',
    template: require('./cart-table.html'),
    controller: CartTableController,
    bindings: {
        carts: '<',
        rootDomain: '<',
        query: '<',
    },
};

export default CartTableComponent;



// WEBPACK FOOTER //
// ./src/app/home/cart-table/index.js